/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/aria-role */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import React, { useState, useEffect } from 'react';
// ALL MATERIAL UI COMPONENTS AND THEME
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import './LoginOptions.css';

// IMPORTING ICONS
// import fbIcon from '@assets/images/social-media-icons/facebook4x.png';
// IMPORTING COMPONENTS
import LoginFooter from '@features/Authentication/components/LoginFooter/LoginFooter';
import LoginViaGoogle from '../LoginViaGoogle/LoginViaGoogle';
import LoginViaApple from '../LoginViaAppleComponent/LoginViaApple';

const useStyles = makeStyles((theme) => ({
  loginModalTitle: {
    color: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    lineHeight: '28px',
    fontStyle: 'normal',
    width: '300px',
    fontFamily: 'CircularXX-Bold, sans-serif !important',
    verticalAlign: 'top',
  },
  loginModalSubErrorTitle: {
    color: '#fb2961',
    width: '320px',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0px',
    fontSize: '12px',
  },
  loginOptionsTitle: {
    color: '#000000',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '14px',
    lineHeight: '15px',
    fontFamily: 'CircularXX-Bold, sans-serif !important',
    marginTop: '2px',
  },
  loginModalSubTitle: {
    color: '#ffffff',
    minWidth: '320px',
    maxWidth: '320px',
    alignItems: 'center',
    fontWeight: '450',
    lineHeight: '18px',
    fontSize: '14px',
    fontFamily: 'CircularXX-Book',
    verticalAlign: 'top',
  },
  loginModalAgreement: {
    color: '#ffffff',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: '450',
    lineHeight: '16px',
    opacity: '50%',
    width: '320px',
  },
  loginModalDescription: {
    color: '#ffffff',
    width: '320px',
    alignItems: 'center',
    fontWeight: '450',
    lineHeight: '18px',
    fontSize: '14px',
    fontFamily: 'CircularXX-Book',
  },
  sendAppModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  },
  paper: {
    background: 'linear-gradient(137.62deg, #04043B 0%, #280548 61.29%);',
    boxShadow: theme.shadows[5],
    color: '#fff',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '580px',
    padding: '30px',
    margin: '0 10px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },

}));

function LoginOptions({
  modalFunc,
  loggedInFunc,
  banModalStatusFunc,
  setBanDetailsFunc,
  setSubLabelText,
  setMainCopy,
  noReCaptchaCheck,
  ...props
}) {
  // import the custom styles from useStyles
  const classes = useStyles();

  // theme from material ui
  const theme = useTheme();

  // responsive states
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [subLabelErrorText, setSubLabelTextError] = useState(null);
  useEffect(() => {
    if (props.subLabelText) {
      setSubLabelTextError(props.subLabelText);
    } else {
      setSubLabelTextError(null);
    }
  }, [props.subLabelText]);

  useEffect(() => () => setMainCopy('Log in to kumu'), []); // bring back modal title header when leave the component

  // hide loginviaQrCode button if user is on mobile
  const hideLoginViaQrCode = () => {
    if (isMobile || isTablet) {
      return 'none';
    }
    return '';
  };

  return (
    <>
      <Grid
        item
        xs={12}
        align='center'
        style={{
          position: 'fixed',
          top: 90,
          left: 60,
          right: 60,
        }}
      >
        <Grid container justifyContent='center' alignItems='center'>
          <Typography
            className={classes.loginModalTitle}
            gutterBottom
          >
            {props.mainCopy}
          </Typography>
          <Typography
            align='center'
            className={classes.loginModalSubTitle}
          >
            By continuing,
            you agree to kumu’s
            {' '}
            <a href='https://kumu.ph/terms-of-use/' target='_blank' className='text-white' rel='noreferrer'><u>Terms of Use</u></a>
            {' '}
            and acknowledge you’ve read our
            {' '}
            <a href='https://kumu.ph/privacy-policy/' target='_blank' className='text-white' rel='noreferrer'><u>Privacy Policy</u></a>
          </Typography>
          <Typography
            align='center'
            className={classes.loginModalSubErrorTitle}
            style={isMobile ? { marginBottom: '0px' } : {
              marginLeft: '40px', marginRight: '40px', marginBottom: '0px', paddingLeft: '30px', paddingRight: '30px',
            }}

          >
            {subLabelErrorText}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        align='center'
        style={{
          position: 'fixed',
          top: 210,
          left: 60,
          right: 60,
        }}
      >
        <>
          {/* <Grid container justifyContent='center' alignItems='center'>
          </Grid> */}
          <Grid container justifyContent='center' alignItems='center'>
            <Grid item container style={{ justifyContent: 'center', alignItems: 'center', margin: '3px 5px' }}>
              <div className='login-options js-btn-step' onClick={() => (!noReCaptchaCheck ? props.loginViaUsername() : setMainCopy('Sorry, that didn\'t work. Try a different option?'))} role='sso_login' data-toggle='tooltip' title='Login via Username'>
                <Typography
                  variant='h6'
                  component='h6'
                  align='center'
                  className={classes.loginOptionsTitle}
                >
                  Use username
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              container
              className='login-qr-container'
              style={{
                display: hideLoginViaQrCode(),
                justifyContent: 'center',
                alignItems: 'center',
                margin: '3px 5px',
              }}
            >
              <div className='login-options js-btn-step' onClick={() => props.loginViaQR()} role='qr_login' data-toggle='tooltip' title='Login via QR Code'>
                <Typography
                  variant='h6'
                  component='h6'
                  align='center'
                  className={classes.loginOptionsTitle}
                >
                  Use QR code
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              container
              style={{ justifyContent: 'center', alignItems: 'center', margin: '3px 5px' }}
            >
              <div role='google_login'>
                <LoginViaGoogle
                  modalFunc={modalFunc}
                  loggedInFunc={loggedInFunc}
                  showLoginViaGoogle={props.showLoginViaGoogle}
                  loginViaGoogle={props.loginViaGoogle}
                  googleError={props.googleError}
                />
              </div>
            </Grid>
            <Grid item style={{ justifyContent: 'center', alignItems: 'center', margin: '3px 5px' }}>
              <div className='login-options js-btn-step' role='apple_login' data-toggle='tooltip' title='Login via Apple'>
                <LoginViaApple
                  modalFunc={modalFunc}
                  loggedInFunc={loggedInFunc}
                  appleError={props.appleError}
                />
              </div>
            </Grid>
          </Grid>
        </>
      </Grid>
      <Grid
        item
        xs={12}
        align='center'
        style={{
          position: 'fixed',
          top: isTablet ? 400 : 440,
          left: 60,
          right: 60,
        }}
      >
        <Grid container justifyContent='center' alignItems='center'>
          <Grid
            item
            style={isMobile ? { marginBottom: '30px', paddingTop: '25px', display: 'flex' } : { marginBottom: '40px', paddingTop: '20px', display: 'flex' }}
            align='left'
          >
            <Typography
              variant='h4'
              align='center'
              className={classes.loginModalAgreement}
              gutterBottom
            >
              This site is protected by reCAPTCHA and the Google
              {' '}
              <a href='https://policies.google.com/privacy?hl=en' target='_blank' className='text-white' rel='noreferrer'><u>Privacy Policy</u></a>
              {' '}
              and
              {' '}
              <a href='https://policies.google.com/terms?hl=en' target='_blank' className='text-white' rel='noreferrer'><u>Terms of Service</u></a>
              {' '}
              apply.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <LoginFooter loginModalDescription={classes.loginModalDescription} />
    </>

  );
}

export default LoginOptions;
